import { render, staticRenderFns } from "./privSchoolFacility.vue?vue&type=template&id=ec93633c&scoped=true&"
import script from "./privSchoolFacility.vue?vue&type=script&lang=js&"
export * from "./privSchoolFacility.vue?vue&type=script&lang=js&"
import style0 from "./privSchoolFacility.vue?vue&type=style&index=0&id=ec93633c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec93633c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
